/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
} from './GeoPoint';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
} from './Image';
import type { OpeningSchedule } from './OpeningSchedule';
import {
    OpeningScheduleFromJSON,
    OpeningScheduleFromJSONTyped,
    OpeningScheduleToJSON,
} from './OpeningSchedule';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
} from './Stock';

/**
 * Representation of a Point Of Service Stock
 * @export
 * @interface PointOfServiceStock
 */
export interface PointOfServiceStock {
    /**
     * Name of the point of service
     * @type {string}
     * @memberof PointOfServiceStock
     */
    name?: string;
    /**
     * Display name of the point of service
     * @type {string}
     * @memberof PointOfServiceStock
     */
    displayName?: string;
    /**
     * Url address of the point of service
     * @type {string}
     * @memberof PointOfServiceStock
     */
    url?: string;
    /**
     * Description of the point of service
     * @type {string}
     * @memberof PointOfServiceStock
     */
    description?: string;
    /**
     * 
     * @type {OpeningSchedule}
     * @memberof PointOfServiceStock
     */
    openingHours?: OpeningSchedule;
    /**
     * Store content of given point of service
     * @type {string}
     * @memberof PointOfServiceStock
     */
    storeContent?: string;
    /**
     * List of features for a given point of service
     * @type {{ [key: string]: string; }}
     * @memberof PointOfServiceStock
     */
    features?: { [key: string]: string; };
    /**
     * 
     * @type {GeoPoint}
     * @memberof PointOfServiceStock
     */
    geoPoint?: GeoPoint;
    /**
     * Distance to the point of service as text value
     * @type {string}
     * @memberof PointOfServiceStock
     */
    formattedDistance?: string;
    /**
     * Distance to the point of service as number value
     * @type {number}
     * @memberof PointOfServiceStock
     */
    distanceKm?: number;
    /**
     * 
     * @type {Image}
     * @memberof PointOfServiceStock
     */
    mapIcon?: Image;
    /**
     * 
     * @type {Address}
     * @memberof PointOfServiceStock
     */
    address?: Address;
    /**
     * Collection of images associated with a point of service
     * @type {Array<Image>}
     * @memberof PointOfServiceStock
     */
    storeImages?: Array<Image>;
    /**
     * Instructions used for picking up an order in store
     * @type {string}
     * @memberof PointOfServiceStock
     */
    pickUpInStoreInstructions?: string;
    /**
     * 
     * @type {Stock}
     * @memberof PointOfServiceStock
     */
    stockInfo?: Stock;
}

/**
 * Check if a given object implements the PointOfServiceStock interface.
 */
export function instanceOfPointOfServiceStock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PointOfServiceStockFromJSON(json: any): PointOfServiceStock {
    return PointOfServiceStockFromJSONTyped(json, false);
}

export function PointOfServiceStockFromJSONTyped(json: any, ignoreDiscriminator: boolean): PointOfServiceStock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'openingHours': !exists(json, 'openingHours') ? undefined : OpeningScheduleFromJSON(json['openingHours']),
        'storeContent': !exists(json, 'storeContent') ? undefined : json['storeContent'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'geoPoint': !exists(json, 'geoPoint') ? undefined : GeoPointFromJSON(json['geoPoint']),
        'formattedDistance': !exists(json, 'formattedDistance') ? undefined : json['formattedDistance'],
        'distanceKm': !exists(json, 'distanceKm') ? undefined : json['distanceKm'],
        'mapIcon': !exists(json, 'mapIcon') ? undefined : ImageFromJSON(json['mapIcon']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'storeImages': !exists(json, 'storeImages') ? undefined : ((json['storeImages'] as Array<any>).map(ImageFromJSON)),
        'pickUpInStoreInstructions': !exists(json, 'pickUpInStoreInstructions') ? undefined : json['pickUpInStoreInstructions'],
        'stockInfo': !exists(json, 'stockInfo') ? undefined : StockFromJSON(json['stockInfo']),
    };
}

export function PointOfServiceStockToJSON(value?: PointOfServiceStock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'displayName': value.displayName,
        'url': value.url,
        'description': value.description,
        'openingHours': OpeningScheduleToJSON(value.openingHours),
        'storeContent': value.storeContent,
        'features': value.features,
        'geoPoint': GeoPointToJSON(value.geoPoint),
        'formattedDistance': value.formattedDistance,
        'distanceKm': value.distanceKm,
        'mapIcon': ImageToJSON(value.mapIcon),
        'address': AddressToJSON(value.address),
        'storeImages': value.storeImages === undefined ? undefined : ((value.storeImages as Array<any>).map(ImageToJSON)),
        'pickUpInStoreInstructions': value.pickUpInStoreInstructions,
        'stockInfo': StockToJSON(value.stockInfo),
    };
}

